import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TdLoadingService } from '@covalent/core';
import { Observable } from 'rxjs/Observable';

import { AbstractIdeaList, Employee } from '../../shared';
import { Status, IdeaService } from '../../services/idea.service';
import { AdminService } from '../../services/admin/admin.service';
import { PetitionAdminConfigs } from '../../shared/admin-models/interfaces/petition-admin-configs.interface';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-idea-list-my',
  templateUrl: './idea-list-my.component.html',
  styleUrls: ['./idea-list-my.component.scss']
})
export class IdeaListMyComponent extends AbstractIdeaList {
  /**
   *
   */
  filterParams: { [key: string]: any } = {};

  /**
   * List of categories
   */
  employees: Employee[] = [];
  signersNeededAmount: number;
  authorised: boolean = false;
  /**
   * Constructor
   *
   * @param _activatedRoute
   * @param _loadingService
   * @param _ideaService
   */
  constructor(
    protected _activatedRoute: ActivatedRoute,
    protected _loadingService: TdLoadingService,
    protected _ideaService: IdeaService,
    private adminService: AdminService,
    private _authService: AuthService
  ) {
    super(_activatedRoute, _loadingService, _ideaService);
  }

  /**
   * Init
   */
  ngOnInit() {
    this._authService.isLoggedIn().subscribe(
      (res) => {
        if (res) {
          this.authorised = true;
          this._subs.add(
            Observable.combineLatest(
              [this._activatedRoute.data, this._activatedRoute.queryParams],
              (data, queryParams) => ({ data, queryParams })
            ).subscribe((ap) => {
              const { id } = ap.data['sessionData'];

              this.searchParams = { userId: id };

              const { categoryId } = ap.queryParams;

              this.filterParams = { categoryId };

              this._getAllIdeas();
            })
          );
          this.getconfigs();
        } else {
          document.location.href = `${this.ssoUrl}/public/auth/login?redirectUrl=${document.location.href}`;
        }
      },
      (err) => {
        document.location.href = `${this.ssoUrl}/public/auth/login?redirectUrl=${document.location.href}`;
      }
    );
  }
  get ssoUrl(): string {
    return environment.ssoUrl;
  }
  getconfigs(): void {
    this.adminService.getConfigs().subscribe((res: PetitionAdminConfigs) => {
      this.signersNeededAmount = res.petitionCounterValue;
    });
  }
  /**
   * Returns observables
   */
  protected get _observables$() {
    const observables$ = this.statuses.map((tab) => this._getIdeas(tab));

    // Get Employee
    observables$.push(this._getEmployee());

    // Get Categories
    observables$.push(this._getCategories());

    return observables$;
  }

  /**
   * List of statuses/tabs
   */
  get statuses() {
    return IdeaService.statuses.filter((status) => true);
  }

  /**
   * Returns the employee
   */
  get employee() {
    return this.employees[0];
  }

  /**
   * Gets ideas by status
   *
   * @param status
   * @param page
   * @param size
   */
  protected _getIdeas(
    status: Status,
    page: number = 0,
    size: number = this.pageSize
  ) {
    const data = Object.assign(
      { statusIds: [status.statusId, ...status.includes] },
      this.searchParams,
      this.filterParams
    );
    if (status.statusId === 5) {
      data.statusIds.push(4);
    }
    return this._getIdeasBase(status, data, { page, size }, { ...this._sort });
  }

  /**
   * Gets categories
   */
  protected _getCategories() {
    const data = Object.assign(
      { statusIds: this._statuses },
      this.searchParams
    );
    return this._getCategoriesBase(data);
  }

  /**
   * Gets employee
   */
  private _getEmployee() {
    const data = Object.assign(
      { statusIds: this._statuses },
      this.searchParams
    );
    return this._ideaService.employeeSearchWithCounts(data).do((res: any) => {
      if (res.result['errors']) {
        // console.log(res);
      } else if (res['result'].data) {
        this.employees = res['result'].data;
      }
    });
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/idea-list-my/idea-list-my.component.ts